import React, { useMemo } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import propTypes from "../../../../../constants/propTypes";
import BWGrid from "../../../../ui/BWGrid/BWGrid";
import GridHeader from "../../../../ui/BWGrid/GridHeader";
import GridTable from "../../../../ui/BWGrid/GridTable";
import LocationCombined from "../../../../ui/LocationCombined";

const Wrapper = styled.div`
  border-bottom: solid 1px rgba(0, 0, 0, 0.12);
  border-top: solid 1px rgba(0, 0, 0, 0.12);
`;

const columns = ["name", "location.address"];
const columnsOptions = {
  name: { bold: true },
  "location.address": {
    fill: true,
    title: "Address",
    render: LocationCombined,
  },
};
// Row menu disabled - addresses are read-only and come from property
const getRowMenu = () => () => null;

const ProjectAddressGrid = ({ rows }) => {
  const rowMenu = useMemo(() => getRowMenu(), []);
  const gridConfig = useMemo(() => ({ pageSize: 0, totalRows: rows.length }), [
    rows.length,
  ]);

  return (
    <Wrapper>
      <BWGrid gridConfig={gridConfig} rows={rows}>
        <GridHeader subheaderText="Project Addresses" actions={[]} />
        <GridTable
          columns={columns}
          columnOptions={columnsOptions}
          rowMenu={rowMenu}
        />
      </BWGrid>
    </Wrapper>
  );
};
ProjectAddressGrid.propTypes = {
  rows: PropTypes.arrayOf(propTypes.contingency),
};

export default ProjectAddressGrid;
